<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-05 20:04:05
 * @LastEditors: yd
 * @LastEditTime: 2020-11-30 10:54:27
 * @FilePath: \mrc-base-server-view\src\components\myConfirm\myConfirm.vue
-->
<template>
  <transition name="fade">
    <v-overlay :value="dialog"
               :dark='false'
               style="z-index:999999"
               @click="action(false)">

      <v-card width="320"
              rounded="lg">
        <v-card-title class="headline error"
                      color="error"
                      primary-title>
          {{title || $t('message_tips')}}
          <!-- <v-icon color="yellow accent-4">mdi-alert-outline</v-icon> -->
        </v-card-title>

        <v-card-text class="pa-10 text--primary">{{content}}?</v-card-text>

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
                 rounded
                 style="letter-spacing:normal;color:var(--main-color);text-transform:capitalize"
                 v-if="cancelShow"
                 @click="action(false)">
            {{cancelText || $t('label_cancel')}}
          </v-btn>
          <v-btn style="letter-spacing:normal;color:var(--main-color);text-transform:capitalize"
                 rounded
                 text
                 @click="action(true)">
            {{successText || $t('label_determine')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>

  </transition>

</template>

<script>
export default {
  name: 'myConfirm',
  components: {},
  data () {
    return {
      loading: false,
      dialog: false,
      content: '确认内容',
      title: '',
      promiseStatus: null,
      successText: '',
      cancelText: '',
      cancelShow: true
    };
  },
  created () { },
  mounted () {
  },
  methods: {
    confirm (fn) {
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.promiseStatus = { resolve, reject }
      })
    },
    action (status) {
      if (status) {
        this.promiseStatus && this.promiseStatus.resolve()
        this.hide()
      } else {
        this.promiseStatus && this.promiseStatus.reject()
        this.hide()
      }
    },
    hide () {
      this.dialog = false;
    }
  },
  computed: {},
  watch: {
  },
};
</script>

<style scoped>
.confirm {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 325px;
}
</style>
